import { render, staticRenderFns } from "./BranchForm.vue?vue&type=template&id=884bf4f6&scoped=true&"
import script from "./BranchForm.vue?vue&type=script&lang=ts&"
export * from "./BranchForm.vue?vue&type=script&lang=ts&"
import style0 from "./BranchForm.vue?vue&type=style&index=0&id=884bf4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884bf4f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VIcon,VRow,VTextField,VTextarea})
